import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { BadgeAlt as Badge } from '@cargomatic/ui';
import { cn } from 'utils/ui/classes';

const AppointmentConfirmationBadge = ({ confirmed, className }) => {
  const { t } = useTranslation();
  const text = confirmed ? titleize(t('CONFIRMED')) : t('NOT_CONFIRMED');
  const color = confirmed
    ? 'bg-green-100 text-green-800 border-green-300'
    : 'bg-red-100 text-red-800 border-red-300';

  return (
    <Badge
      variant="outline"
      className={cn('whitespace-nowrap shrink-0', color, className)}
    >
      {text}
    </Badge>
  );
};
AppointmentConfirmationBadge.propTypes = {
  confirmed: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

export default AppointmentConfirmationBadge;
